import React from 'react';
import { DollarIcon as StyledDollarIcon } from './DollarIcon.styled';

export interface DollarIconProps {
  className?: string;
}

export function DollarIcon({ className }: DollarIconProps) {
  return <StyledDollarIcon className={className} />;
}
